import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusColor',
  // standalone: true,
})
export class statusColorText implements PipeTransform {
  transform(value: any): string | null {
    switch (value) {
      case 'ACTIVE':
        return '#15ac64';
      case 'INACTIVE':
        return '#ea001b';
      case 'Approved':
        return '#15ac64';
      case 'Rejected':
        return '#cb4b32';
    }
    return value;
  }
}
